import { Card, Row, Col, Statistic } from "antd";
import { UserOutlined, BookOutlined } from "@ant-design/icons";

export default function Dashboard() {
  return (
    <Row gutter={16}>
      <Col span={6}>
        <Card>
          <Statistic
            title="Usuarios activos"
            value={128}
            prefix={<UserOutlined />}
          />
        </Card>
      </Col>
      <Col span={6}>
        <Card>
          <Statistic
            title="eBooks publicados"
            value={42}
            prefix={<BookOutlined />}
          />
        </Card>
      </Col>
    </Row>
  );
}
